export default "__VITE_ASSET___vqstK0c__"